<section class="secondary-drawer-container">
    <button class="drawer-close-btn mat-elevation-z0" mat-mini-fab aria-label="Close" (click)="dismiss()">
        <mat-icon>close</mat-icon>
    </button>
    <h5 class="drawer-title">Video Viewer</h5>
</section>
<div>
    <video src="{{file}}" width="100%" height="100%" controls>
    </video>
</div>